// export const API_BASE_URL = 'http://localhost:4501/api/v1/';
export const API_BASE_URL = 'https://api.greenlandcommodities.africa//api/v1/';
export const CLIENT_SECRET = 'client_secret=f97da8ff-8c21-4c62-a6bb-5768d5726225'
export const accesstoken = 'accesstoken';


